import { createSlice } from "@reduxjs/toolkit";
import { fetchAccountTree } from "../thunks/accountSummary";

const accountSlice = createSlice({
  name: "accountTree",
  initialState: {
    accountTree: [],
  },
  reducers: {
    setAccountTree: (state, action) => {
      state.accountTree = action.payload;
    },
    addNewClient: (state, action) => {
      state.accountTree.push(action.payload);
    },
    updateClient: (state, action) => {
      const index = state.accountTree.findIndex(accounts => accounts.id === action.payload.id);
      if (index !== -1) {
        state.accountTree[index] = action.payload;
      }
    },
    deleteClient: (state, action) => {
      state.accountTree = state.accountTree.filter(accounts => accounts.id !== action.payload);
    },

    addNewAccount: (state, action) => {
      state.accountTree.push(action.payload);
    },
    updateAccount: (state, action) => {
      const index = state.accountTree.findIndex(accounts => accounts.id === action.payload.id);
      if (index !== -1) {
        state.accountTree[index] = action.payload;
      }
    },
    deleteAccount: (state, action) => {
      state.accountTree = state.accountTree.filter(accounts => accounts.id !== action.payload);
    },
  },
  extraReducers: (builders) => {
    builders.addCase(fetchAccountTree.fulfilled, (state, action) => {
      state.accountTree = action.payload
    })
  }
});
export const { setAccountTree ,addNewClient,updateClient,deleteClient, addNewAccount,updateAccount,deleteAccount} = accountSlice.actions;

export default accountSlice.reducer;
